'use client'

import { createContext, useContext } from 'react'

const DeliveryAppContext = createContext()

export const useDeliveryAppContext = () => {
  return useContext(DeliveryAppContext)
}

export default DeliveryAppContext
